import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const BusinessContinuity = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/trust/security/security-practices#faq-d323ae61-59b8-4ddb-96d4-30716b603e3e"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.BusinessContinuity.header",
            defaultMessage: "Business continuity and disaster recovery"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.BusinessContinuity.body",
            defaultMessage:
                "Our Disaster Recovery Program consists of a few key practices to ensure the appropriate levels of governance, oversight, and testing."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.BusinessContinuity.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about security practices."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default BusinessContinuity;
